/**
 * Copyright Mántum All Rights Reserved.
 */
import Body from './body';
import Sidebar from './sidebar';
import { useEffect, useState } from 'react';

import type { Contexts, Advanced, Group, Groups } from './type';

type PropTypes = {
    advanced?: Advanced;
    contexts?: Contexts;
    groups?: Groups;
    message?: string;
    onClick?: (value: unknown) => void;
    onClose?: () => void;
    placeholder?: string;
    spaces?: number;
};

export default function Content(props: PropTypes) {
    const {
        groups = [],
        contexts = [],
        message = 'No data',
        spaces = 2
    } = props;

    const [selected, setSelected] = useState<Group>();

    useEffect(() => {
        groups.forEach((group) => {
            if (group.default) {
                setSelected(group);
            }
        });
    }, [groups]);

    return (
        <nav className='fixed left-0 top-0 z-20 grid h-screen w-full auto-cols-auto grid-flow-col bg-accent sm:left-0 md:absolute md:left-auto md:top-auto md:mt-2 md:max-h-[32rem] md:w-auto md:rounded-md'>
            <Sidebar onClick={setSelected} items={groups} selected={selected} />
            <Body
                advanced={props.advanced}
                contexts={contexts}
                message={message}
                onClick={props.onClick}
                onClose={props.onClose}
                placeholder={props.placeholder}
                selected={selected}
                spaces={spaces}
            />
        </nav>
    );
}
